import AcademicContractDaysFields from './AcademicContractDaysFields.component';

export default AcademicContractDaysFields;
